import { DigitalGpSubmission, TrackingCodes } from '@sky-distribution/digital-gp-submission';

const DISCOUNT_CODE_TRACKING_CODE_NAME = 'DISCOUNT_CODE';

const EMPLOYEE_ID_UTM_NAME = 'utm_employee_id';
const SALES_CHANNEL_UTM_NAME = 'utm_medium';
const AFFILIATE_LINK_VERSION_UTM_NAME = 'utm_aff_link_version';

export const UTM_NAME_TO_PRODUCER_DATA_KEY_MAP = {
  [EMPLOYEE_ID_UTM_NAME]: 'employeeId',
  [SALES_CHANNEL_UTM_NAME]: 'salesChannel',
  [AFFILIATE_LINK_VERSION_UTM_NAME]: 'utmAffLinkVersion',
};

export type ProducerDataTrackingCodes = {
  employeeId?: string;
  salesChannel?: string;
  utmAffLinkVersion?: string;
};

export const getProducerDataTrackingCodes = (
  trackingCodes: TrackingCodes,
) => Object.entries(trackingCodes)
  .reduce((producerData, [name, value]): ProducerDataTrackingCodes => {
    const producerDataKey = UTM_NAME_TO_PRODUCER_DATA_KEY_MAP[name];

    return producerDataKey
      ? {
        ...producerData,
        [producerDataKey]: value,
      }
      : producerData;
  }, {} as ProducerDataTrackingCodes);

export const getDigitalTrackingCodesFromUtms = (
  utms: Record<string, string>,
): TrackingCodes | undefined => {
  if (!Object.keys(utms).length) {
    return undefined;
  }

  return Object.entries(utms)
    .reduce((trackingCodes, [name, value]) => ({
      ...trackingCodes,
      [name]: value,
    }), {});
};

export const getSubmissionWithTrackingCodes = (
  submission: DigitalGpSubmission,
  trackingCodes: TrackingCodes,
): DigitalGpSubmission => {
  const mergedTrackingCodes = {
    ...trackingCodes,
    ...submission.baseData.trackingCodes,
  };

  return {
    ...submission,
    baseData: {
      ...submission.baseData,
      trackingCodes: mergedTrackingCodes,
    },
  };
};

export const getDigitalTrackingCodesFromSubmission = (
  submission: DigitalGpSubmission,
): TrackingCodes => submission?.baseData?.trackingCodes ?? {};

export const getDiscountCodeFromTrackingCodes = (
  trackingCodes: TrackingCodes,
): string => trackingCodes[DISCOUNT_CODE_TRACKING_CODE_NAME];
